import {Howl, Howler} from "howler";
import * as PIXI from "pixi.js";
import data from "../configs/data";
import {Button} from "../controlElements/Button";
import {CheckBox} from "../controlElements/CheckBox";
import {HowToPlay} from "../HowToPlay";
import {SettingsMenu} from "../SettingsMenu";
import {IToolbarMenu} from "./IToolbarMenu";

export class ToolBarMenu extends PIXI.Container implements IToolbarMenu {

    private openCloseButton: Button;
    private volumeCheckBox: CheckBox;
    private infoButton: Button;
    private settingsButton: Button;
    private isOpened: boolean = true;

    private readonly OPEN_CLOSE_BUTTON_POSITION = new PIXI.Point(0, 0);
    private readonly INFO_BUTTON_POSITION = new PIXI.Point(0, -45);
    private readonly SETTINGS_BUTTON_POSITION = new PIXI.Point(0, -90);
    private readonly VOLUME_CHECKBOX_POSITION = new PIXI.Point(0, -135);

    constructor() {
        super();
        this.createAndAddVolumeCheckbox();
        this.createAndAddSettingsButton();
        this.createOpenCloseButton();
        this.createInfoButton();
        this.close();
    }

    public close(): void {
        this.isOpened = false;
        this.volumeCheckBox.visible = false;
        this.infoButton.visible = false;
        this.settingsButton.visible = false;
    }

    public open(): void {
        this.isOpened = true;
        this.volumeCheckBox.visible = true;
        this.infoButton.visible = true;
        this.settingsButton.visible = true;
    }

    public toggleVisibility(): void {
        if (this.isOpened) {
            this.close();
        } else {
            this.open();
        }
    }

    private createInfoButton(): void {
        this.infoButton = new Button(data.images.infoBase, data.images.infoHover, data.images.infoClick,
            data.images.infoInactive, data.audios.buttonClicked);
        this.infoButton.position = this.INFO_BUTTON_POSITION;
        this.addChild(this.infoButton);
        this.infoButton.subscribeOnClicked(() => {
            HowToPlay.getInstance().toggleVisibility();
        });
    }

    private createAndAddSettingsButton(): void {
        this.settingsButton = new Button(data.images.settingsBase, data.images.settingsHover,
            data.images.settingsClick, data.images.settingsInActive, data.audios.buttonClicked);
        this.settingsButton.position = this.SETTINGS_BUTTON_POSITION;
        this.addChild(this.settingsButton);
        this.settingsButton.subscribeOnClicked(() => {
            SettingsMenu.getInstance().toggleVisibility();
        });
    }

    private createOpenCloseButton(): void {
        this.openCloseButton = new Button(data.images.optionsBase, data.images.optionsHover,
            data.images.optionsClick, data.images.optionsInActive, data.audios.buttonClicked);
        this.openCloseButton.position = this.OPEN_CLOSE_BUTTON_POSITION;
        this.addChild(this.openCloseButton);
        this.openCloseButton.subscribeOnClicked(() => {
            this.toggleVisibility();
            SettingsMenu.getInstance().close();
        });
    }

    private createAndAddVolumeCheckbox(): void {
        this.volumeCheckBox = new CheckBox(data.images.volumeOffBase, data.images.volumeOffHover,
            data.images.volumeOffClick, data.images.volumeOffInActive, data.images.volumeOnBase,
            data.images.volumeOnHover, data.images.volumeOnClick,
            data.images.volumeOnInActive, data.audios.buttonClicked);
        this.volumeCheckBox.checked = true;
        this.volumeCheckBox.position = this.VOLUME_CHECKBOX_POSITION;
        this.addChild(this.volumeCheckBox);
        this.volumeCheckBox.subscribeOnClicked((isChecked) => {
            if (isChecked) {
                Howler.volume(1.0);
            } else {
                Howler.volume(0.0);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/ToolBarMenu.ts